import React, { useState } from 'react';
import { object, string } from 'prop-types';
import classNames from 'classnames';

import { CATEGORIES, VIRTUAL_CATEGORY_GROUPS } from '../../../config/marketplace-custom-config';
import css from './CategorySidebar.module.css';

const CategorySidebar = ({ className, history, location }) => {
  const [openSecondary, setOpenSecondary] = useState(null); // e.g. 'dog-food'
  const rootClassName = classNames(css.root, className);

  const updateSearch = (paramsUpdater) => {
    const searchParams = new URLSearchParams(location.search || '');
    paramsUpdater(searchParams);

    history.push({
      pathname: location.pathname,
      search: `?${searchParams.toString()}`,
    });
  };

  // Click on "Dog Food", "Dog Beds", etc.
  const handleSecondaryClick = (mainKey, secondaryKey) => {
    updateSearch(searchParams => {
      searchParams.set('pub_category', mainKey);

      const group = VIRTUAL_CATEGORY_GROUPS[secondaryKey];
      if (group && group.length) {
      // Multi-enum field: match ANY of these values (OR), not ALL.
      // e.g. pub_subcategory=has_any:dry-dog-food,wet-dog-food,vegan-dog-food
      searchParams.set('pub_subcategory', `has_any:${group.join(',')}`);
    } else {
      // leaf or fallback
      searchParams.set('pub_subcategory', secondaryKey);
    }
    });

    setOpenSecondary(prev => (prev === secondaryKey ? null : secondaryKey));
  };

  // Click on a specific leaf like "Dog Dry Food"
  const handleLeafClick = (mainKey, leafKey) => {
    updateSearch(searchParams => {
      searchParams.set('pub_category', mainKey);
      searchParams.set('pub_subcategory', leafKey);
    });
  };

  return (
    <nav className={rootClassName}>
      <h3 className={css.title}>Categories</h3>
      <ul className={css.mainList}>
        {Object.values(CATEGORIES).map(main => (
          <li key={main.key} className={css.mainItem}>
            <div className={css.mainLabel}>{main.label}</div>
            <ul className={css.secondaryList}>
              {main.subCategories.map(secondary => {
                const isOpen = openSecondary === secondary.key;

                return (
                  <li key={secondary.key} className={css.secondaryItem}>
                    <button
                      type="button"
                      className={classNames(css.secondaryButton, {
                        [css.secondaryButtonOpen]: isOpen,
                      })}
                      onClick={() => handleSecondaryClick(main.key, secondary.key)}
                    >
                      {secondary.label}
                    </button>

                    {isOpen && secondary.subCategories && secondary.subCategories.length > 0 && (
                      <ul className={css.leafList}>
                        {secondary.subCategories.map(leaf => (
                          <li key={leaf.key} className={css.leafItem}>
                            <button
                              type="button"
                              className={css.leafButton}
                              onClick={() => handleLeafClick(main.key, leaf.key)}
                            >
                              {leaf.label}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  );
};

CategorySidebar.defaultProps = {
  className: null,
};

CategorySidebar.propTypes = {
  className: string,
  history: object.isRequired,
  location: object.isRequired,
};

export default CategorySidebar;
